
import AuthLayout from '@/layouts/AuthLayout/AuthLayout.vue';
import SignInForm from './SignInForm/SignInForm.vue';

export default {
  components: {
    AuthLayout,
    SignInForm,
  },
};
